// Mirrors the server enums in node/utils/constants/user_tips.js (like admin_scope_constants) —
// server-side validation remains the source of truth.
export const CRITERIA_TYPES = {
  NEXT_APP_OPEN: 'next_app_open',
  USER_CREATION_AGE: 'user_creation_age'
};

export const CRITERIA_OPTIONS = [
  { value: CRITERIA_TYPES.NEXT_APP_OPEN, label: 'Next app open' },
  { value: CRITERIA_TYPES.USER_CREATION_AGE, label: 'Account age' }
];

export const AUDIENCE_MATCH_OPTIONS = [
  { value: 'any', label: 'Any selected tag' },
  { value: 'all', label: 'All selected tags' }
];

export const PLATFORM_OPTIONS = [
  { value: 'BOTH', label: 'Both' },
  { value: 'MOBILE', label: 'Mobile' },
  { value: 'WEB', label: 'Web' }
];

export const PRIORITY_HINT = 'Choose 1-5. Lower shows first after all code-defined onboarding tips.';
